<template>
  <div>
    <a-calendar style="background: #fff" @select="onSelect">
      <ul slot="dateCellRender" slot-scope="value" class="events" v-if="value.format('YYYY-MM-DD') === row.date">
        <!--      {{ value.format('YYYY-MM-DD') }}-->
        <li v-for="item in row.sai" :key="item.id" v-if="row.sai && row.sai.length > 0">
          <a-badge status="success" :text="item.name"/>
        </li>
        <li v-for="item in row.huiyi" :key="item.id" v-if="row.huiyi && row.huiyi.length > 0">
          <a-badge status="success" :text="item.name"/>
        </li>
      </ul>
    </a-calendar>
    <a-modal
        title="操作"
        :width="800"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="visible = false"
    >

      <a-divider v-if="row.sai && row.sai.length > 0">进行中的赛事</a-divider>
      <li v-for="item in row.sai" :key="item.id" v-if="row.sai && row.sai.length > 0">
        <a-badge status="success" :text="item.name"/>
      </li>
      <a-divider v-if="row.huiyi && row.huiyi.length > 0">进行中的培训</a-divider>

      <li v-for="item in row.huiyi" :key="item.id" v-if="row.huiyi && row.huiyi.length > 0">
        <a-badge status="success" :text="item.name"/>
      </li>
      <template slot="footer">
        <a-button key="cancel" @click="visible = false">取消</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import {activityCalendar} from "@/api/analysis";

export default {
  data() {
    return {
      visible: false,
      row: {}
    }
  },
  mounted() {
    let that = this
    activityCalendar().then(res => {
      console.log(res.data)
      // that.sellerCount = res.data.sellerCount;
      // that.pvTotal = res.data.pvTotal;
      // that.pvToday = res.data.pvToday;
      // that.pvChartData = res.data.pvChartData;
      // that.payChartData = res.data.payChartData;
      // that.orderCount = res.data.orderCount;
      // that.userCount = res.data.userCount;
      // that.userToday = res.data.userToday;
      // that.userRankList = res.data.userRankList;
      // that.orderPriceChartData = res.data.orderPriceChartData
      // that.goodsRankList = res.data.goodsRankList
      // that.shopGoodsRankList = res.data.shopGoodsRankList
      // that.userChartData = res.data.userChartData

      that.row = res.data

    })
  },
  methods: {
    onSelect(value) {
      console.log(value)
      if(value.format('YYYY-MM-DD') != this.row.date) {
        return
      }
      this.visible = true
    }
  },
};
</script>
<style scoped>
.events {
  list-style: none;
  margin: 0;
  padding: 0;
}

.events .ant-badge-status {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
}

.notes-month {
  text-align: center;
  font-size: 28px;
}

.notes-month section {
  font-size: 28px;
}
</style>
